import { createSelector } from 'reselect';

const selectLogin = (state: any) => state.login;

export const selectLoginResponse = createSelector([selectLogin], (login) => login.loginResponse);

// export const getLoginObjDetails = createSelector(
// 	[selectLogin],
// 	(login): LoginDetails | null => login.loginResponse
// );

export const getLoginObjDetails = createSelector([selectLogin], (login) => {
	let loginObj: any = {
		jwtToken: '',
	};
	if (login?.loginResponse) {
		const { jwtToken } = login.loginResponse;

		loginObj = {
			jwtToken,
		};
	}

	return loginObj;
});
